export const requestHost = (host) => () => async (action) => {
  return {
    ...action,
    endpoint: `${host}${action.endpoint}`,
  };
};
